import { svgInject } from '../modules/svg-injection';
import { alertMessage } from '../modules/alert-message';
import { mobileMenu } from '../modules/mobile-menu';
import { mobileNav } from '../modules/mobile-nav';
//import { adageLibrary } from '../modules/adage-library';
import { dataEdit } from '../modules/data-edit';
import { formValidation } from '../modules/form-validation';
import { initializePasswordValidation } from '../modules/form-validation';
import { inputNumberSpinner } from '../modules/input-number-spinner';
import { modals } from '../modules/modals';
import { mainNav } from '../modules/main-nav';
import { popupCartNav, popupCartNavClearCart, utilityNav, clearCartUpdate, initPopupCart, disablePopUpCartCheckoutCta } from '../modules/utility-nav';
import { scrollCheck } from '../modules/scroll-check';
import { myAccountMenuApp } from '../modules/my-account-menu';
import { addAddress } from '../pages/add-address';
import { membershipInstallment } from '../pages/membership-installment';
import { backToTop } from '../modules/back-to-top';
import { formErrorLinks } from '../modules/form-error-links';
import { Accordion } from '../modules/accordion';
import { nodeListToArray } from '../helpers/nodeListToArray';
import { Gallery } from '../modules/gallery';
import { SvgSprite } from '../modules/svg-sprite';
import { initializeLightbox } from '../modules/lightbox';
import { initializeTagManagerTags } from '../modules/tag-manager';
import { initializeSubNavScrolling } from '../modules/horizontal-scroll';
import { initializeRadioAndCheckboxFocus } from '../modules/radio-checkbox';
import { accessibleDropdown } from '../modules/accessible-dropdown';
import { initializePasswordToggle } from '../modules/hide-show-password';
import { initializeHoverFocusEvents } from '../modules/hover-focus-states';
import { initializeVideoModals } from '../modules/video-modal';
import { ctaCardChecker } from '../modules/cta-card-checker';
import {fiftyFiftyChecker } from '../modules/fiftyfifty-checker';
import { dropzoneInit } from '../modules/dropzone';
import { FullBleedImage } from '../modules/fullBleedImagesIE';
import { DropDownAnchorsNav } from '../modules/DropDownAnchorsNavigation';

import 'objectFitPolyfill';

import inlineTrim from '../modules/read-more-less-trim';
import { VimeoThumbnailFetch } from '../modules/vimeo-thumbnail-fetch';
import { StateDropdownChanger } from '../modules/state-dropdown-changer';
import { DynamicCompanyName } from '../modules/dynamic-company-name';
import { BrowserAlert } from '../modules/BrowserAlert';
import { checkThumbnails } from '../modules/youtube-thumbnail';
import { initMembershipHistory } from '../modules/membership-history-accordion';
import { initializeAnchorLinks } from '../modules/anchor-links';
import { initCampaignsAndToolkits } from '../modules/campaigns-toolkits';
import { initializeMacy } from '../modules/masonry-layout';
import { ProductCarousel } from '../modules/shop-carousel';
import { isIntersecting } from '../modules/intersection-observer'
import { GlobalNotificationBanner } from '../modules/global-notification-banner'
//import { initPeeriusRecs } from '../modules/recommended-courses';
import { sendOnlineCourseSeriesListScriptToGTM, sendProductGroupBlockListingScriptsToGTM } from '../modules/shop-google-analytics';
import { renderRecs } from '../modules/recommended-courses';
import { tooltips } from '../modules/tooltip';

//declare global {
//    interface Window {
//        InitPeeriusRecommendationsForRecommendedCoursesBlock: (data: any) => void
//    }
//}
//declare tooltips as global for react apps to utilize tooltips
declare global {
    interface Window {
        Tooltips: () => void;
    }
}
window.Tooltips = function () { tooltips(); };
(function () {
    // Request SVG sprite
    var hash = (Math.floor(Math.random() * 1000)).toString();
    svgInject('/static/imgs/svg-sprite.svg?v=' + hash);
    // End Request SVG sprite

    //window.InitPeeriusRecommendationsForRecommendedCoursesBlock = function (data) {
    //    const recClass = 'peerius-reccomended-courses';
    //    const courseRecs = nodeListToArray(document.querySelectorAll('[data-recommended-courses-campaign]'));

    //    if (courseRecs.length > 0) {
    //        courseRecs.forEach((course, index) => {
    //            course.classList.add(`${recClass}-${index}`);
    //            //let campaignId = course.getAttribute("data-recommended-courses-campaign");
    //            // getPeeriusData(`${recClass}-${index}`, campaignId, course);
    //            renderRecs(data[0], `${recClass}-${index}`, course)
    //        });
    //    }

    //}

    const vimeoThumbnailFetch = new VimeoThumbnailFetch();
    alertMessage();
    mobileMenu();   // will be removed
    mobileNav();
    myAccountMenuApp();
    formValidation();
    modals();
    mainNav();
    utilityNav();
    popupCartNav();
    popupCartNavClearCart();
    disablePopUpCartCheckoutCta();
    inputNumberSpinner();
    scrollCheck();
    backToTop();
    formErrorLinks();
    dataEdit();
    (window as any).objectFitPolyfill();
    ctaCardChecker();
    fiftyFiftyChecker();
    BrowserAlert();
    inlineTrim;
    dropzoneInit();
    membershipInstallment();
    initPopupCart();
    tooltips();
    
    new StateDropdownChanger();
    new DynamicCompanyName();
    new GlobalNotificationBanner();
    // Loading adage library module
    //adageLibrary();

    // Pages
    //addAddress();

    const sprites = new SvgSprite('/Static-Adage/img/adage-sprite.svg')

    // Epi Kit
    const accordions = new Accordion({ oneOpenAtATime: false })
    const galleryClass = 'single-item-gallery';
    const galleries = nodeListToArray(document.querySelectorAll('[data-gallery]'));

    galleries.forEach((gallery, index) => {
        gallery.classList.add(`${galleryClass}-${index}`);
        new Gallery({
            containerClass: `${galleryClass}-${index}`,
            slidesPerView: 1
        })
    });

    const productCarousels = nodeListToArray(document.querySelectorAll('[data-product-carousel]'));
    const carouselClass = 'product-carousel';

    productCarousels.forEach((carousel, index) => {
        carousel.classList.add(`${carouselClass}-${index}`);
        new ProductCarousel({
            containerClass: `${carouselClass}-${index}`,
            slidesPerView: 1
        })
    });

    sendProductGroupBlockListingScriptsToGTM();
    sendOnlineCourseSeriesListScriptToGTM();

    //mobile shop cart is in view
    isIntersecting('[data-intersection-observer="info-cart"]','[data-intersection-observer="mini-cart"]')

    // Fix images in IE that must be full-bleed
    let fullBleedImages = nodeListToArray(document.querySelectorAll('[data-full-bleed-image] .adage-image-block img'));
    fullBleedImages.forEach(imageEl => {
        new FullBleedImage(imageEl);
    });

    // Drop Down Anchors Nav
    if (DropDownAnchorsNav) {
        DropDownAnchorsNav.init();
    }

    // Video Modals Init
    initializeVideoModals();

    initializeHoverFocusEvents();
    initializePasswordValidation();
    initializePasswordToggle();
    initializeTagManagerTags();
    initializeLightbox();
    initializeSubNavScrolling();
    initializeRadioAndCheckboxFocus();
    accessibleDropdown();
    checkThumbnails();
    initMembershipHistory();
    initializeAnchorLinks();
    initCampaignsAndToolkits();
    initializeMacy();
    //initPeeriusRecs();
})();

